// must be in global scope for recaptcha to work properly
// used in the onload attribute of the recaptcha script
window.recaptcha4i = recaptcha4i;

function recaptcha4i(){
    const logos = document.getElementsByClassName('grecaptcha-logo');
    if (logos.length > 0) {
        var logoIframe = logos[0].getElementsByTagName('iframe');
        if (logoIframe.length > 0) {
            // Adds title to iframe
            logoIframe[0].setAttribute('title', 'Google reCAPTCHA Logo');	
            // Hides iframe from screen readers
            logoIframe[0].setAttribute('hidden', 'true');
        }
    }

    var response = document.getElementById('g-recaptcha-response-100000');
    if (response) {
        response.setAttribute('aria-label', 'reCAPTCHA response');
    }


    var recaptchaForms = document.getElementsByClassName('recaptchaForm');
    for (var i = 0; i < recaptchaForms.length; i++){
        var rForm = recaptchaForms[i];
        var rSiteKey;
        var siteKeyElements = rForm.getElementsByClassName('recaptchaSiteKey');
        if (siteKeyElements.length > 0) {
            rSiteKey = siteKeyElements[0].value;
        } else {
            console.error("recaptchaSiteKey element not found in form");
            return; // Exit the function if the element is not found
        }
        var actionNameElements = rForm.getElementsByClassName('recaptchaActionName');
        var rActionName;
        if (actionNameElements.length > 0) {
            rActionName = actionNameElements[0].value;
        } else {
            console.error("recaptchaActionName element not found in form");
            return; // Exit the function if the element is not found
        }
    
        function executeRecaptcha(siteKey, actionName, callback){
            grecaptcha.execute(siteKey, { action: actionName }).then(function (token) { 
                callback(token);
            });
        }

        rForm.onsubmit = function (e) {
            e.preventDefault();
            executeRecaptcha(rSiteKey, rActionName, function(token) {
                rForm.getElementsByClassName('recaptchaToken')[0].value = token;
                rForm.submit();
            });
        };
    }
}


class Recaptcha {
	constructor (){}

    // Get the key for the recaptcha script
    // adding in more descriptive error management
    init = async () => {
        try{
            const response = await fetch('/header/recaptchasitekey', {
                method: 'POST', 
                headers: { 'X-Requested-With': 'fetch' }
            });
            //if(!response.ok) throw new Error(`Error processing request: ${response.statusText}`);
            const responseJSON = await response.json();

            if(!responseJSON.siteKey || responseJSON.siteKey.length < 1){
                console.error("Failed to retrieve recaptchasitekey")
                return;
            }

            let recaptchaResponse = "";
            if(responseJSON){
                recaptchaResponse = responseJSON;
            }else{
                var backup = document.getElementById('backupgrecaptcha');
                if(backup) recaptchaResponse = { 'siteKey': backup.value };
                else recaptchaResponse = { 'siteKey': ''};
            }

            if(!document.getElementById("recaptcha4i")){
                await this.addScript(recaptchaResponse.siteKey);
            }
            return recaptchaResponse;
        }catch(error){
            console.error(error);
            throw new Error(`Error processing recaptcha request: ${error}`);
        }
    };

    addScript = async (siteKey) => {
        let recapEl = document.createElement('script'); 
        recapEl.type = 'text/javascript'; 
        recapEl.async = true; 
        recapEl.id = 'recaptcha4i';
        
        // Use the globally accessible function in the onload attribute
        recapEl.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey + '&onload=recaptcha4i'; 
        const capBod = document.getElementsByTagName('body')[0]; 
        capBod.appendChild(recapEl);
    }
}

export default new Recaptcha();